// https://github.com/DavidWells/analytics#creating-analytics-plugins

import { HttpClient } from '@angular/common/http'
import { AnalyticsPlugin } from 'analytics'

import { TrackingAnalyticsIdentifyTraits } from './tracking.service'

export interface ChurnzeroConfig {
  appKey: string
  httpClient: HttpClient
  trackingUrl: string
}

// Uses CZ HTTP API
// https://support.churnzero.net/hc/en-us/articles/360003183171-Integrate-ChurnZero-using-HTTP-API
export function churnzeroPlugin(config: ChurnzeroConfig): AnalyticsPlugin {
  const httpClient = config.httpClient

  let user: TrackingAnalyticsIdentifyTraits
  let identifyTime: Date

  const sendTrackingRequest = (
    action: string,
    params: Record<string, string>,
  ): void => {
    if (user) {
      httpClient
        .get(config.trackingUrl, {
          params: {
            action,
            appKey: config.appKey,
            accountExternalId: user.verityCustomerCode,
            contactExternalId: user.email,
            ...params,
          },
          responseType: 'blob',
          observe: 'response',
        })
        .subscribe()
    }
  }

  return {
    name: 'churnzero',
    /*
    initialize: (): void => {
      // load provider script to page
    },
    */

    // call provider specific page tracking
    page: (): void => {
      // TODO: debounce to a 15+ second window if this becomes too noisy for every page nav event.
      if (identifyTime) {
        sendTrackingRequest('trackTimeInApp', {
          startDate: identifyTime.toISOString(),
          endDate: new Date().toISOString(),
        })
      }
    },

    // call provider specific event tracking
    track: ({ payload }: { payload: { event: string } }): void => {
      sendTrackingRequest('trackEvent', {
        eventName: payload.event,
      })
    },

    // call provider specific user identify method
    identify: ({
      payload,
    }: {
      payload: { traits: TrackingAnalyticsIdentifyTraits }
    }): void => {
      user = payload.traits
      identifyTime = new Date()
    },

    // return boolean so analytics knows when it can send data to third-party
    loaded: (): boolean => {
      return true
    },
  }
}
